export const HomePageCohabitationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Convivenza',
    path: '/convivenza',
  },
];

export const CommonCohabitationCrumbs = [
  ...HomePageCohabitationCrumbs,
  {
    name: 'Ricerca Convivenza',
    path: '/convivenza/ricerca',
  },
];

export const DetailCohabitationCrumbs = [
  ...CommonCohabitationCrumbs,
  {
    name: 'Dettaglio Convivenza',
    path: '/convivenza/dettaglio',
  },
];

export const EditCohabitationCrumbs = [
  ...CommonCohabitationCrumbs,
  {
    name: 'Modifica Convivenza',
    path: '/convivenza/modifica',
  },
];

export const InsertCohabitationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Convivenza',
    path: '/convivenza',
  },
  {
    name: 'Inserisci Convivenza',
    path: '/convivenza/inserimento',
  },
];

export const CancellationCohabitationCrumbs = [
  ...CommonCohabitationCrumbs,
  {
    name: 'Cancellazione Convivenza',
    path: '/convivenza/cancellazione',
  },
];

export const HistoryCohabitationCrumbs = [
  ...CommonCohabitationCrumbs,
  {
    name: 'Storico Convivenza',
    path: '/convivenza/ricerca/storico',
  },
];
